import React from "react";
import { Button, Icon } from 'react-materialize';

export default function ExportSheetBtn({ handleEvents }) {
    return <Button
        flat
        node="button"
        waves="light"
        className="btn-top-right textcolor-green"
        id="btn-export"
        onClick={handleEvents.OnClick}
    >
        Export to sheet
        <Icon right>launch</Icon>
    </Button>
}